import { graphql } from '@/generated/gql';

export const DEMAND_FILE_ATTACHMENTS_QUERY = graphql(/* GraphQL */ `
  query DemandFileAttachments($parents: [TsrctAttachmentParentInput!]!, $filter: TsrctAttachmentFilterInput) {
    tesseract {
      attachments(parents: $parents, filter: $filter) {
        ...FileAttachment
      }
    }
  }
`);

export const DEMAND_FILE_ATTACHMENTS_DEMAND_QUERY = graphql(/* GraphQL */ `
  query DemandFileAttachmentsDemand($demandId: UUID!) {
    tesseract {
      demand(id: $demandId) {
        id
        status
        negotiationCases {
          nodes {
            id
            status
          }
        }
      }
    }
  }
`);
